import React from 'react';
import './style.scss';

export interface UQGridProps {
  children: React.ReactNode;
  gap?: string;
  justify?: 'start' | 'end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
  align?: 'start' | 'end' | 'center' | 'stretch' | 'baseline';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  columns?: number;
  className?: string;
}

const UQGrid: React.FC<UQGridProps> = ({
  children,
  gap = '',
  justify = 'start',
  align = 'stretch',
  alignItems,
  columns,
  className = '',
}) => {
  const style: React.CSSProperties & { [key: string]: any } = { gap };
  if (columns) {
    style.flexWrap = 'wrap';
    style.rowGap = gap;
    style.columnGap = gap;
  }
  if (alignItems) {
    style.alignItems = alignItems;
  }

  return (
    <div
      className={`grid justify-${justify} align-${align} ${className}`}
      style={style}
    >
      {React.Children.map(children, (child, idx) =>
        columns
          ? (
            <div
              className="uq-grid-col"
              style={{
                flex: `1 1 calc(${100 / columns}% - ${gap})`,
                maxWidth: `calc(${100 / columns}% - ${gap})`,
              }}
            >
              {child}
            </div>
          )
          : child
      )}
    </div>
  );
};

export default UQGrid;